import React from 'react';
import Header from './Header';
import Footer from './footer';
import './DetailAllergy.css';
import { translateUiText } from '../i18n';

const DetailAllergy = ({
  allergy,
  title,
  userLanguageBrowser,
  locale = 'en',
  flagUrl,
  iconAssets,
  showRealImages,
  onClose,
  onPlaySound,
  getAllergyImageUrl,
  onImageError
}) => {
  const handlePlayAllergen = () => {
    if (allergy?.audioUrl) {
      onPlaySound(allergy.audioUrl);
    }
  };

  if (!allergy) return null;

  return (
    <div className="detail-allergy-overlay">
      <div className="detail-allergy-container">
        {/* Header */}
        <Header
          title={title}
          leftIcon={iconAssets?.warning}
          rightIcon={flagUrl}
          locale={locale}
        />

        {/* Main content */}
        <div className="detail-allergy-content">
          <div className="detail-allergy-image-container">
            <img
              className="detail-allergy-image"
              src={getAllergyImageUrl(allergy)}
              alt={allergy.name}
              onError={(event) => onImageError?.(event, allergy)}
            />
            {/* Red cross lines */}
            <div className="detail-cross-line line1"></div>
            <div className="detail-cross-line line2"></div>
          </div>

          <h1 className="detail-allergy-title">{allergy.translation}</h1>
          {userLanguageBrowser !== "en" && (
            <p className="detail-allergy-subtitle">{allergy.name}</p>
          )}
        </div>

        {/* Footer */}
        <Footer locale={locale} />

        {/* Action buttons */}
        <div className="detail-action-bar">
          <button
            className={`detail-action-btn ${!allergy?.audioUrl ? 'disabled' : ''}`}
            onClick={handlePlayAllergen}
            disabled={!allergy?.audioUrl}
          >
            {iconAssets?.speaker && (
              <img src={iconAssets.speaker} alt={translateUiText(locale, 'speakerAlt')} className="detail-action-icon" />
            )}
          </button>
          <button
            className="detail-action-btn close-btn"
            onClick={onClose}
            aria-label={translateUiText(locale, 'close')}
          >
            <span className="close-icon">×</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DetailAllergy;
